/** Returns BOL data as plain key-value pairs, filtering out empty values.
 *  Values are now stored as literal strings (no @[varId] markup) so no resolution is needed. */
export const resolveBolRequirementsData = (bolData: Record<string, string>): Record<string, string> => Object.fromEntries(Object.entries(bolData).filter(([, v]) => Boolean(v)));
